import { UserState } from "./types";
import { User } from "@/models/user_schema";

export const setUser = (state: UserState, data: User) => {
  state.user = data;
};

export const setError = (state: UserState, error: boolean) => {
  state.error = error;
};
